module.exports = fox._r("fonts/icon-mc_other2.eot?ctdsoz", __webpack_public_path__ + "_/_/_/common/frame/fonts/1ifXtfO.eot");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/fonts/icon-mc_other2.eot?ctdsoz
// module id = 26
// module chunks = 2